// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__cSXE9","inner":"Form_inner__2l0KR","range":"Form_range__u4OuC","name":"Form_name__ZYibu","actions":"Form_actions__vj6IM"};